import styled from '@emotion/styled';
import { SVGProps } from 'react';

/**
 * An svg element using the mask properties to render an icon with different colors
 * @param src - path to the svg mask
 * @param size - size of the icon (width and height)
 * @param color - color of the icon (default: currentcolor)
 * @param padding - padding of the icon (default: 0)
 * @param rotated - rotate the icon by 180deg (default: false)
 * @param margin - margin of the icon (default: 0)
 * @param width - overrides width of the icon (default: size)
 * @returns an svg element
 */
export interface IMaskedIcon extends SVGProps<SVGSVGElement> {
    src: string;
    size: string;
    color?: string;
    padding?: string;
    rotated?: boolean;
    margin?: string;
    width?: string;
    cursor?: string;
}
export const MaskedIcon = styled.svg<IMaskedIcon>`
    background-color: ${({ color }) => color || 'currentcolor'};
    mask: url(${({ src }) => src}) no-repeat center left;
    mask-size: contain;
    min-width: ${({ width, size }) => width ?? size};
    width: ${({ width, size }) => width ?? size};
    height: ${({ size }) => size};
    padding: ${({ padding }) => padding || '0'};
    margin: ${({ margin }) => margin || '0'};
    transform: ${({ rotated }) => (rotated ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 0.2s ease-in-out;
    ${({ cursor }) => cursor && `cursor: ${cursor};`}
`;
